import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-03183eb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"color":"white"} }

import { Toast } from '@/interfaces/ToastInterface';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastMessage',
  props: ['message', 'type'],
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({animate:true, toastcontainer:true, info:props.type == _unref(Toast).INFO, success:props.type == _unref(Toast).SUCCESS, warning:props.type == _unref(Toast).WARNING, danger:props.type == _unref(Toast).DANGER})
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(props.message), 1)
  ], 2))
}
}

})